<template>
    <loading-skeleton :loadingHeight="'300px'" v-if="!chartActive"/>

    <div v-show="(inTransitCount > 0) || (deliveredCount > 0) || (currentCount > 0)" class="donut-container">
        <canvas ref="myChart" class="donut-chart" id="donut"></canvas>
    </div>
    <p v-if="(inTransitCount == 0) && (deliveredCount == 0) && (currentCount == 0)" class="selected-range no-shipments">No Shipments</p>
    <p v-if="sliderValue >= 1 && sliderValue < 2" class="selected-range">Todays shipments</p>
    <p v-if="sliderValue >= 2 && sliderValue < 3" class="selected-range">7 days of shipments</p>
    <p v-if="sliderValue == 3" class="selected-range">{{dayRangeValue}} day(s) of shipments</p>
    <div v-if="false" class="slidecontainer">
        <input type="range" v-model="sliderValue" min="1" max="3" step="1" class="slider" id="myRange">
        <div class="slider-range">
            <div>Day</div>
            <div class="middle-range">Week</div>
            <div>Month</div>
        </div>
    </div>
    <div class="slidecontainer">
        <ol class="steplist">
            <li :class="{ active: index === 2 }" v-for="(item, index) in sliderValueArray" :key="item.value" @click="SetSliderValue(item.value)">{{item.label}}</li>
        </ol>
    </div>
    <br>
    <div class="button-container">
        <button class="main-button-green-white" @click="showCurrent()">Current</button>
        <button class="main-button-blue-white" @click="showInTransit()">In Transit</button>
        <button class="main-button-orange-white" @click="showDelivered()">Delivered</button>  
    </div>

    <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
</template>

<script>
import Chart from 'chart.js/auto'
import {API} from 'aws-amplify';
import LoadingSkeleton from '../../ShipmentDashboard/LoadingSkeleton.vue'
import AlertUser from '../../Popups/AlertUser.vue';

export default {
    components:{
        AlertUser,
        LoadingSkeleton
    },
    props:['refreshAfterVoidBool', 'userData', 'selectedAccountNo', 'countDateRangeDelivered'],
    data(){
        return{
            sliderValue: 3,
            sliderValueArray:[
                {value: 1, label: "Day"},
                {value: 2, label: "Week"},
                {value: 3, label: "Range"}
            ],
            fromDate: "",
            toDate: "",
            deliveredCount: null,
            inTransitCount: null,
            currentCount: null,
            currentShipmentCount: 10,
            changeDataArrayInput: [],
            changeDataLabelInput: null,
            donutChart: null,
            chartOptions: {
                        responsive: true,
                        fullSize: true
                    },
            chartData : {
                labels: [
                    'Current',
                    'In Transit',
                    'Delivered'
                ],
                datasets: [{
                    label: 'My First Dataset',
                    data: [10, 15, 30],
                    backgroundColor: [
                    '#33f18a',
                    '#32ccfe',
                    '#fe804d'
                    ],
                    hoverOffset: 4
                }]
            },
            toggleAlertBox: false,
            alertMessage: "",
            CurrentKey: null,
            beforeTodaysDate: null,
            todaysDate: null,
            sevenDaysDate: null,
            thirtyDaysDate: null,
            sixtyDaysDate: null,
            chartActive: false,
            dayRangeValue: '',
            currentMonth: '',
            previousMonth: '',
            previousMonthName: '',
            items: `items{
                    shipmentID
                    }`
        }
    },
    watch:{
        'selectedAccountNo':function(){
            if(this.selectedAccountNo != "")
            {
                this.CurrentKey = this.selectedAccountNo;
                this.chartActive = false;
                if(this.donutChart){
                    this.donutChart.destroy();
                }
                
                this.createMyChartDoughnut();
                this.getInTransitShipmentsGraphQL();
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get account data to generate table."
            }
        },
        chartDataComputed(newDataSet){
            this.donutChart.destroy();
            this.chartData.datasets.data = newDataSet;
            this.createMyChartDoughnut();
        },
        'sliderValue':function() {
            this.chartActive = false;
            if(this.sliderValue == 1){
                this.toDate = this.todaysDate;
                this.fromDate = this.sevenDaysDate;
                this.$emit('selectedBetweenDates', {fromDate: this.fromDate, toDate: this.toDate, sliderValue: this.sliderValue})
            }else if(this.sliderValue == 2){
                this.toDate = this.todaysDate;
                this.fromDate = this.sevenDaysDate;
                this.$emit('selectedBetweenDates', {fromDate: this.fromDate, toDate: this.toDate, sliderValue: this.sliderValue})
            }else if(this.sliderValue == 3){
                this.toDate = this.todaysDate;
                this.fromDate = this.thirtyDaysDate;
                this.$emit('selectedBetweenDates', {fromDate: this.fromDate, toDate: this.toDate, sliderValue: this.sliderValue})
            }

            this.donutChart.destroy();
            this.createMyChartDoughnut();
        },
        'refreshAfterVoidBool':function(){
            this.chartActive = false;
            this.donutChart.destroy();
            this.createMyChartDoughnut();
        },
        'countDateRangeDelivered':function(){
            this.updateCount(this.countDateRangeDelivered.deliveredCount, this.countDateRangeDelivered.deliveredRange)
        }
    },
    computed:{
        chartDataComputed(){
            return this.chartData.datasets[0].data, this.chartData.labels;
        }
    },
    methods:{
        updateCount(count, dateRange){
            const parsedDateRange = dateRange.map(d => new Date(d.year, parseInt(d.month, 10) - 1, d.day));

            // calculate consecutive differences
            const msPerDay = 1000 * 60 * 60 * 24;
            const gaps = [];
            for (let i = 0; i < parsedDateRange.length - 1; i++) {
                const diff = Math.abs((parsedDateRange[i + 1] - parsedDateRange[i]) / msPerDay);
                gaps.push(diff);
            }

            const totalDays = Math.abs((parsedDateRange.at(-1) - parsedDateRange[0]) / msPerDay);
            this.dayRangeValue = totalDays;
            
            this.chartActive = false;
            this.donutChart.destroy();
            this.deliveredCount = count
            this.createMyChartDoughnutDateRange();
        },
        async getCurrentShipmentsGraphQL() {
            let allItems = [];
            let nextToken = null;

            try {
                do {
                    const graphqlQuery = `query shipmentByCurrentKey {
                        shipmentByCurrentKey(currentKey: "${this.CurrentKey}", limit: 1000, nextToken: ${nextToken ? `"${nextToken}"` : null}) {
                            ${this.items}
                            nextToken
                        }
                    }`;

                    // Fetch data with the current query
                    const response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const currentItems = response.data.shipmentByCurrentKey.items;
                    allItems = allItems.concat(currentItems);

                    nextToken = response.data.shipmentByCurrentKey.nextToken;
                } while (nextToken); // Continue fetching if nextToken is present

                this.currentCount = allItems.length;

            } catch (e) {
                console.log(e);
                if (e) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting current shipments";
                }
            } finally {
                this.loading = false;
            }
        },
        async getInTransitShipmentsGraphQL() {
            let allItems = [];
            let nextToken = null;
            
            try {
                do {
                    const graphqlQuery = `query shipmentByInTransitKey{
                        shipmentByInTransitKey(inTransitKey: "${this.CurrentKey}", limit: 1000, nextToken: ${nextToken ? `"${nextToken}"` : null}){
                            ${this.items}
                            nextToken
                        }
                    }`
                    ;

                    // Fetch data with the current query
                    const response = await API.graphql({
                        query: graphqlQuery,
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const currentItems = response.data.shipmentByInTransitKey.items;
                    allItems = allItems.concat(currentItems);

                    nextToken = response.data.shipmentByInTransitKey.nextToken;

                } while (nextToken); // Continue fetching if nextToken is present

                this.inTransitCount = allItems.length;

            } catch (e) {
                console.log(e);
                if (e) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting in transit shipments";
                }
            } finally {
                this.loading = false;
            }
        },
        async getDeliveredShipmentsGraphQL() {
            let nextToken = null;
            let HistoryKey = this.CurrentKey + '-' + this.currentMonth;
            let DeliveryDayTo = this.toDate.slice(8, 10);
            let DeliveryDayFrom = this.fromDate.slice(8, 10);
            //const thisMonthDate = new Date();
            const previousMonthDate = new Date();

            // Set the current date to the first day of the current month
            previousMonthDate.setDate(1);
            // Subtract one day to get to the last day of the previous month
            previousMonthDate.setDate(0);
            //let previousMonthKey = this.CurrentKey + '-' + previousMonthDate.toJSON().slice(0, 7);
            const numberOfDays = previousMonthDate.getDate(); // Get the number of days in the previous month

            let previousMonthHistoryKey = this.CurrentKey + "-" + this.fromDate.slice(0, 7);
            //let thisMonthName = thisMonthDate.toLocaleString('default', { month: 'long' });
            let previousMonthName = previousMonthDate.toLocaleString('default', { month: 'long' });

            this.dayRangeValue = "30";
            this.previousMonthName = previousMonthName;

            //let deliveredCountPreMonth = 0;
            let deliveredCountCurrentMonth = 0;

            try {
                switch (this.sliderValue) {
                    case 1:
                        this.deliveredCount = 0;
                        // Fetch deliveries for the current month
                        do {
                            try {
                                let shipmentByHistoryKeyCurrentMonth = await API.graphql({
                                    query: `query shipmentByHistoryKeyDeliveryDay {
                                        shipmentByHistoryKeyDeliveryDay(
                                            historyKey: "${HistoryKey}",
                                            deliveryDay: {eq: "${DeliveryDayTo}"},
                                            limit: 1000,
                                            ${nextToken ? `nextToken: "${nextToken}"` : ''}
                                        ) {
                                            ${this.items}
                                            nextToken
                                        }
                                    }`,
                                    authMode: "AMAZON_COGNITO_USER_POOLS",
                                });
                                deliveredCountCurrentMonth += shipmentByHistoryKeyCurrentMonth.data.shipmentByHistoryKeyDeliveryDay.items.length;
                                nextToken = shipmentByHistoryKeyCurrentMonth.data.shipmentByHistoryKeyDeliveryDay.nextToken;
                            } catch (e) {
                                console.log(e);
                                if (e) {
                                    this.toggleAlertBox = true;
                                    this.alertMessage = "Error getting delivered shipments";
                                }
                            }
                        } while (nextToken);

                        this.deliveredCount =  deliveredCountCurrentMonth;
                        
                        break;

                    case 2:
                        this.deliveredCount = 0;
                        if (DeliveryDayFrom > DeliveryDayTo) {
                            // Fetch deliveries for the previous month
                            let deliveredCountPreMonth = 0;
                            do {
                                try {
                                    let shipmentByHistoryKeyPrevMonth = await API.graphql({
                                        query: `query shipmentByHistoryKeyDeliveryDay {
                                            shipmentByHistoryKeyDeliveryDay(
                                                historyKey: "${previousMonthHistoryKey}",
                                                deliveryDay: {between: ["${DeliveryDayFrom}", "${numberOfDays}"]},
                                                limit: 1000,
                                                ${nextToken ? `nextToken: "${nextToken}"` : ''}
                                            ) {
                                                ${this.items}
                                                nextToken
                                            }
                                        }`,
                                        authMode: "AMAZON_COGNITO_USER_POOLS",
                                    });
                                    deliveredCountPreMonth += shipmentByHistoryKeyPrevMonth.data.shipmentByHistoryKeyDeliveryDay.items.length;
                                    nextToken = shipmentByHistoryKeyPrevMonth.data.shipmentByHistoryKeyDeliveryDay.nextToken;
                                } catch (e) {
                                    console.log(e);
                                    if (e) {
                                        this.toggleAlertBox = true;
                                        this.alertMessage = "Error getting delivered shipments";
                                    }
                                }
                            } while (nextToken);

                            // Reset nextToken for the current month
                            nextToken = null;

                            // Fetch deliveries for the current month
                            let deliveredCountCurrentMonth = 0;
                            do {
                                try {
                                    let shipmentByHistoryKeyCurrentMonth = await API.graphql({
                                        query: `query shipmentByHistoryKeyDeliveryDay {
                                            shipmentByHistoryKeyDeliveryDay(
                                                historyKey: "${HistoryKey}",
                                                deliveryDay: {between: ["00", "${DeliveryDayTo}"]},
                                                limit: 1000,
                                                ${nextToken ? `nextToken: "${nextToken}"` : ''}
                                            ) {
                                                ${this.items}
                                                nextToken
                                            }
                                        }`,
                                        authMode: "AMAZON_COGNITO_USER_POOLS",
                                    });
                                    deliveredCountCurrentMonth += shipmentByHistoryKeyCurrentMonth.data.shipmentByHistoryKeyDeliveryDay.items.length;
                                    nextToken = shipmentByHistoryKeyCurrentMonth.data.shipmentByHistoryKeyDeliveryDay.nextToken;
                                } catch (e) {
                                    console.log(e);
                                    if (e) {
                                        this.toggleAlertBox = true;
                                        this.alertMessage = "Error getting delivered shipments";
                                    }
                                }
                            } while (nextToken);

                            this.deliveredCount = deliveredCountPreMonth + deliveredCountCurrentMonth;
                        } else {
                            // Fetch deliveries for the specified date range
                            do {
                                try {
                                    let shipmentByHistoryKey = await API.graphql({
                                        query: `query shipmentByHistoryKeyDeliveryDay {
                                            shipmentByHistoryKeyDeliveryDay(
                                                historyKey: "${HistoryKey}",
                                                deliveryDay: {between: ["${DeliveryDayFrom}", "${DeliveryDayTo}"]},
                                                limit: 1000,
                                                ${nextToken ? `nextToken: "${nextToken}"` : ''}
                                            ) {
                                                ${this.items}
                                                nextToken
                                            }
                                        }`,
                                        authMode: "AMAZON_COGNITO_USER_POOLS",
                                    });
                                    this.deliveredCount += shipmentByHistoryKey.data.shipmentByHistoryKeyDeliveryDay.items.length;
                                    nextToken = shipmentByHistoryKey.data.shipmentByHistoryKeyDeliveryDay.nextToken;
                                } catch (e) {
                                    console.log(e);
                                    if (e) {
                                        this.toggleAlertBox = true;
                                        this.alertMessage = "Error getting delivered shipments";
                                    }
                                }
                            } while (nextToken);
                        }
                        break;

                    case 3:{
                        this.deliveredCount = 0;
                        const now = new Date();
                        const yearNow = now.getUTCFullYear();
                        const monthNow = String(now.getUTCMonth() + 1).padStart(2, "0");
                        const dayNow = String(now.getUTCDate()).padStart(2, "0");

                        // 30 days ago
                        const past = new Date();
                        past.setUTCDate(past.getUTCDate() - 30);
                        const yearPast = past.getUTCFullYear();
                        const monthPast = String(past.getUTCMonth() + 1).padStart(2, "0");
                        const dayPast = String(past.getUTCDate()).padStart(2, "0");

                        const accountNo = this.CurrentKey;

                        const historyKeyNow = `${accountNo}-${yearNow}-${monthNow}`;
                        const historyKeyPast = `${accountNo}-${yearPast}-${monthPast}`;

                        const countWindow = async (historyKey, startDay, endDay) => {
                        let nextToken = null;
                            do {
                                try {
                                    const res = await API.graphql({
                                    query: `query shipmentByHistoryKeyDeliveryDay {
                                        shipmentByHistoryKeyDeliveryDay(
                                        historyKey: "${historyKey}",
                                        deliveryDay: {between: ["${startDay}", "${endDay}"]},
                                        limit: 1000,
                                        ${nextToken ? `nextToken: "${nextToken}"` : ""}
                                        ) {
                                        ${this.items}
                                        nextToken
                                        }
                                    }`,
                                    authMode: "AMAZON_COGNITO_USER_POOLS",
                                    });

                                    const page = res?.data?.shipmentByHistoryKeyDeliveryDay;
                                    this.deliveredCount += page?.items?.length || 0;
                                    nextToken = page?.nextToken || null;
                                } catch (e) {
                                    console.error(e);
                                    this.toggleAlertBox = true;
                                    this.alertMessage = "Error getting delivered shipments";
                                    break; // stop this window on error
                                }
                            } while (nextToken);
                        };

                        // single-month or two-month window
                        if (yearNow === yearPast && monthNow === monthPast) {
                            // last 30 days stay within one month
                            await countWindow(historyKeyNow, dayPast, dayNow);
                        } else {
                            // spans months: past month (dayPast..31) + current month (01..dayNow)
                            await countWindow(historyKeyPast, dayPast, "31");
                            await countWindow(historyKeyNow,  "00",    dayNow);
                        }

                        break;

                        // this.deliveredCount = 0;
                        // do {
                        //     try {
                        //         let shipmentByHistoryKey = await API.graphql({
                        //             query: `query shipmentByHistoryKeyDeliveryDay {
                        //                 shipmentByHistoryKeyDeliveryDay(
                        //                     historyKey: "${HistoryKey}",
                        //                     deliveryDay: {between: ["00", "31"]},
                        //                     limit: 1000,
                        //                     ${nextToken ? `nextToken: "${nextToken}"` : ''}
                        //                 ) {
                        //                     ${this.items}
                        //                     nextToken
                        //                 }
                        //             }`,
                        //             authMode: "AMAZON_COGNITO_USER_POOLS",
                        //         });
                        //         this.deliveredCount += shipmentByHistoryKey.data.shipmentByHistoryKeyDeliveryDay.items.length;
                        //         nextToken = shipmentByHistoryKey.data.shipmentByHistoryKeyDeliveryDay.nextToken;
                        //     } catch (e) {
                        //         console.log(e);
                        //         if (e) {
                        //             this.toggleAlertBox = true;
                        //             this.alertMessage = "Error getting delivered shipments";
                        //         }
                        //     }
                        // } while (nextToken);
                        // break;
                    }
                    default:
                        break;
                }
            } finally {
                this.loading = false;
            }
        },
        async createMyChartDoughnut(){
            await this.getCurrentShipmentsGraphQL(this.CurrentKey);
            await this.getInTransitShipmentsGraphQL(this.CurrentKey);
            await this.getDeliveredShipmentsGraphQL(this.CurrentKey);
            this.chartData.datasets[0].data = [this.currentCount, this.inTransitCount, this.deliveredCount]
            this.donutChart = new Chart(
                this.$refs.myChart,
                {
                    type: 'doughnut',
                    data: this.chartData,
                    options: this.chartOptions
                }
            );
            this.chartActive = true;
        },
        async createMyChartDoughnutDateRange(){
            this.chartData.datasets[0].data = [this.currentCount, this.inTransitCount, this.deliveredCount]
            this.donutChart = new Chart(
                this.$refs.myChart,
                {
                    type: 'doughnut',
                    data: this.chartData,
                    options: this.chartOptions
                }
            );
            this.chartActive = true;
        },
        SetSliderValue(value){
            this.sliderValue = value;
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        showDelivered(){
            this.$emit('selectedShipmentType', "Delivered")
            this.$emit('selectedBetweenDates', {fromDate: this.fromDate, toDate: this.toDate, sliderValue: this.sliderValue})
        },
        showCurrent(){
            this.$emit('selectedShipmentType', "Current")
            this.$emit('selectedBetweenDates', {fromDate: this.fromDate, toDate: this.toDate, sliderValue: this.sliderValue})
        },
        showInTransit(){
            this.$emit('selectedShipmentType', "In Transit")
            this.$emit('selectedBetweenDates', {fromDate: this.fromDate, toDate: this.toDate, sliderValue: this.sliderValue})
        }
    },
    mounted(){
        this.todaysDate = new Date(new Date().setDate(new Date().getDate())).toJSON().slice(0, 10);
        this.sevenDaysDate =  new Date(new Date().setDate(new Date().getDate() - 7)).toJSON().slice(0, 10);
        this.thirtyDaysDate = new Date(new Date().setDate(new Date().getDate() - 29)).toJSON().slice(0, 10);
        this.sixtyDaysDate = new Date(new Date().setDate(new Date().getDate() - 59)).toJSON().slice(0, 10);
        this.fromDate = this.sevenDaysDate;
        this.toDate = this.todaysDate;
        this.currentMonth = this.toDate.slice(0,7);

        let previousMonthDate = new Date();
        // Set the current date to the first day of the current month
        previousMonthDate.setDate(1);
        // Subtract one day to get to the last day of the previous month
        previousMonthDate.setDate(0);
        this.previousMonth = previousMonthDate.toJSON().slice(0,7);

        let canvas = this.$refs.myChart;

        canvas.onclick = (evt) => {
            const res = this.donutChart.getElementsAtEventForMode(
                evt,
                'nearest',
                { intersect: true },
                true
            );
            // If didn't click on a bar, `res` will be an empty array
            if (res.length === 0) {
                return;
            }
            this.$emit('selectedShipmentType', this.donutChart.data.labels[res[0].index])
            this.$emit('selectedBetweenDates', {fromDate: this.fromDate, toDate: this.toDate, sliderValue: this.sliderValue})
        };

        document.querySelectorAll('.steplist').forEach(steplist => {
            steplist.addEventListener('click', function(event) {
                if (event.target.nodeName !== 'LI') return;
                const items = event.target.closest('.steplist').querySelectorAll('li');
                for (const item of items) {
                item.classList.toggle('active', item === event.target);
                }
            });
        });
    }
}
</script>

<style scoped>
@import "../../../styles/button-styles.css";
.button-container {
	width: 100%;
	display: flex;
	justify-content: space-between;
	box-shadow: rgba(0, 0, 0, .15) 0 5px 15px;
	padding: 5px;
	border-radius: 25px
}

.donut-container {
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center
}

.donut-chart {
	width: 100%;
	cursor: pointer
}

.slidecontainer {
	width: 100%;
	margin-top: 10px;
	display: flex;
	justify-content: center
}

.slider {
	-webkit-appearance: none;
	width: 100%;
	height: 15px;
	border-radius: 5px;
	background: #d3d3d3;
	outline: 0;
	opacity: .7;
	-webkit-transition: .2s;
	transition: opacity .2s
}

.slider:hover {
	opacity: 1
}

.slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #fe804d;
	cursor: pointer
}

.slider::-moz-range-thumb {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #fe804d;
	cursor: pointer
}

.selected-range {
	width: fit-content;
	background-color: #fe804d;
	color: #fff;
	padding: 5px 15px;
	border-radius: 99px;
	margin-left: 0;
	transition-duration: .5s;
	animation: animate-selected-range .5s ease
}

.steplist {
	border-top: 2px solid #ccc;
	display: flex;
	list-style-type: none;
	justify-content: space-between;
	margin: 0;
	padding: 0;
	--circle-radius: 8px;
	width: 80%
}

.steplist li {
	color: #999;
	cursor: pointer;
	padding: calc(5px + var(--circle-radius)) 0 0;
	margin: 0;
	position: relative;
	text-align: center;
	font-size: 10px
}

.steplist li::before {
	background-color: #ccc;
	border-radius: 50%;
	content: '';
	position: absolute;
	height: calc(2 * var(--circle-radius));
	width: calc(2 * var(--circle-radius));
	top: 0;
	left: 50%;
	transform: translate(-50%, -50%);
	transition: all .3s ease
}

.steplist .active {
	color: #000
}

.steplist .active::before {
	background-color: #33f18a;
	box-shadow: 0 0 0 3px #2ac26eae;
	z-index: 2
}

.steplist li:first-child::after {
	background-color: #fff;
	content: '';
	position: absolute;
	height: 2px;
	width: 50%;
	top: -2px;
	right: calc(50% + var(--circle-radius))
}

.steplist li:last-child::after {
	background-color: #000;
	content: '';
	position: absolute;
	height: 2px;
	width: 50%;
	top: -2px;
	left: calc(50% + 8px);
	background-color: #fff
}

.no-shipments {
	background-color: #fe804d
}

@keyframes animate-selected-range {
	from {
		margin-left: -50%
	}

	to {
		margin-left: 0
	}
}

.slider-range {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	font-size: 10px
}

.middle-range {
	margin-left: 10%
}
</style>